<template>
  <div>
    <div class="row">
      <div class="col-md-2 col-5 offset-md-3">
        <date-input v-model="searchForm.date_start" alias="Data Inicial" />
      </div>
      <div class="col-md-2 col-5">
        <date-input v-model="searchForm.date_end" alias="Data Final" />
      </div>
      <div class="col-md-2 col-2 d-flex align-items-end">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="select($event)"
          >
            <i class="fas fa-search" />
            <span class="d-md-inline d-none">Pesquisar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-12 offset-md-3">
        <b-form-checkbox
          class="d-block d-md-inline"
          switch
          inline
          :value="true"
          :unchecked-value="false"
          v-model="allAccountPlan"
        >
          <small>Exibir todo plano de contas</small>
        </b-form-checkbox>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-md-6 col-12 offset-md-3">
        <div class="card">
          <div class="card-body">
            <template v-for="(accountPlanGroup, index) in accountPlanGroups">
              <template v-if="shouldShowAccountPlanGroup(accountPlanGroup.id)">
                <div class="row mt-4" :key="'acg' + index">
                  <div class="col-12">
                    <b>{{ accountPlanGroup.description }}</b>
                  </div>
                </div>
                <template
                  v-for="(
                    accountPlan, index
                  ) in getAccountPlansByAccountPlanGroupId(accountPlanGroup.id)"
                >
                  <template v-if="shouldShowAccountPlan(accountPlan.id)">
                    <div class="row" :key="'ac' + accountPlan.id">
                      <div class="col-6">
                        {{ accountPlan.description }}
                      </div>
                      <div
                        :class="[
                          'col-6 text-right',
                          getNumberClass(getValueByAccountPlan(accountPlan.id)),
                        ]"
                      >
                        {{ getValueByAccountPlan(accountPlan.id) | decimal }}
                      </div>
                    </div>
                    <hr
                      class="mb-1 mt-1"
                      :key="'ac' + accountPlan.id + 'hr' + index"
                    />
                  </template>
                </template>
                <!-- <hr :key="'acghr' + index"> -->
              </template>
            </template>
            <div class="row mt-5">
              <div class="col-12">
                <b>Resultados</b>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-6">Entradas</div>
              <div :class="['col-6 text-right', getNumberClass(sumIn)]">
                <b>{{ sumIn | decimal }}</b>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-6">Saídas</div>
              <div :class="['col-6 text-right', getNumberClass(sumOut)]">
                <b>{{ sumOut | decimal }}</b>
              </div>
            </div>
            <hr />
            <div class="row mt-3">
              <div class="col-6">Saldo</div>
              <div
                :class="['col-6 text-right', getNumberClass(sumIn + sumOut)]"
              >
                <h4>{{ (sumIn + sumOut) | decimal }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-handler :error="error" />
  </div>
</template>
<script>
import Filter from "@/mixins/Filters.js";
import moment from "moment";

export default {
  data: function () {
    return {
      searchForm: {
        date_start: moment().startOf("month").format("YYYY-MM-DD"),
        date_end: moment().endOf("month").format("YYYY-MM-DD"),
      },

      allAccountPlan: false,

      accountPlanGroups: {},

      accountPlans: {},

      sumAccountTransactions: {},

      error: null,
    };
  },

  async created() {
    await this.$store
      .dispatch("accountCashFlow/getCashFlowResume", {
        params: this.searchForm,
      })
      .then((response) => {
        this.accountPlanGroups = response.data.accountPlanGroups;

        this.accountPlans = response.data.accountPlans;

        this.sumAccountTransactions = response.data.sumAccountTransactions;

        this.$store.commit("pageHasLoaded");
      })
      .catch((error) => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", { error: error });
      });
  },

  computed: {
    sumIn() {
      let sum = 0;
      for (let index in this.sumAccountTransactions) {
        if (this.sumAccountTransactions[index].sum_value > 0 && index != "") {
          sum += parseFloat(this.sumAccountTransactions[index].sum_value);
        }
      }
      return sum;
    },
    sumOut() {
      let sum = 0;
      for (let index in this.sumAccountTransactions) {
        if (this.sumAccountTransactions[index].sum_value < 0 && index != "") {
          sum += parseFloat(this.sumAccountTransactions[index].sum_value);
        }
      }
      return sum;
    },
  },

  methods: {
    select() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("accountCashFlow/getCashFlowResume", {
          params: this.searchForm,
        })
        .then((response) => {
          this.sumAccountTransactions = response.data.sumAccountTransactions;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
        });
    },

    shouldShowAccountPlanGroup(id) {
      if (this.allAccountPlan) {
        return true;
      }

      let result = false;

      let filteredAccountPlans = this.accountPlans.filter(
        (v) => v.account_plan_group_id == id
      );

      for (let index in filteredAccountPlans) {
        if (
          typeof this.sumAccountTransactions[filteredAccountPlans[index].id] !==
          "undefined"
        ) {
          result = true;
        }
      }

      return result;
    },

    shouldShowAccountPlan(id) {
      if (this.allAccountPlan) {
        return true;
      }

      return typeof this.sumAccountTransactions[id] !== "undefined";
    },

    getAccountPlansByAccountPlanGroupId(id) {
      return this.accountPlans.filter((v) => v.account_plan_group_id == id);
    },

    getValueByAccountPlan(id) {
      if (typeof this.sumAccountTransactions[id] !== "undefined") {
        return this.sumAccountTransactions[id].sum_value;
      } else {
        return 0;
      }
    },

    getNumberClass(value) {
      if (value == 0) {
        return "text-secondary";
      }

      if (value > 0) {
        return "text-success";
      } else {
        return "text-danger";
      }
    },
  },
};
</script>

<style>
</style>